var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { observable, observe, action } from "mobx";
import { mapHasLiveEvents, mapHasLiveStreaming, mapLeagueUrl, sortLeagues, filterLeagues, mapSelected, mapRequiredProps } from "../composable";
import { InternalMessageBusChannels, internalMessageBus } from "sb-internal-msg-bus";
import Debounce from "debounce-decorator";
import { updateLeagueRankID, filterOnlyTopLeagues } from "../helpers";
export class Parser {
    constructor(retriever, config, navigationHandler) {
        this.retriever = retriever;
        this.leagues = [];
        this.selectedLeagues = [];
        this.navigationHandler = navigationHandler;
        this.config = config;
        this.isLoading = false;
        //this.mapLeagueLinkUrl = mapLeagueUrl.bind(this, navigationHandler.Navigation.adjustSportsPath);
        this.onLogin = this.onLogin.bind(this);
        this.globalListeners = {};
        this.globalListeners[InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken] = "renewJWTToken";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogin] = "onLogin";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogout] = "onLogout";
        this.leaguesDisposer = () => { };
        this.sportId = "1";
        this.regionIds = [config.regionId];
        this.sortIPTopLeaguesFirst = config.sortIPTopLeaguesFirst;
    }
    attachMsgBusRouter() {
        Object.keys(this.globalListeners).forEach(x => internalMessageBus.on(x, this.msgRouterGlobal, this));
    }
    detachMsgBusRouter() {
        Object.keys(this.globalListeners).forEach(x => internalMessageBus.off(x, this.msgRouterGlobal, this));
    }
    msgRouterGlobal(msg) {
        this[this.globalListeners[`${msg.channel}.${msg.subChannel.join(".")}`]](...msg.data);
    }
    requestGlobalListeners() {
        internalMessageBus.emit(InternalMessageBusChannels.legacy.userInfo.request, { callback: this.onLogin });
    }
    attachObservables() {
        this.leaguesDisposer = observe(this.retriever, (change) => {
            this.updateLeagues();
        });
    }
    onLogin(user) {
        if (user) {
            this.retriever.setRegionId(user.CountryOfRegistration);
            this.regionIds = [this.config.regionId, user.CountryOfRegistration];
        }
    }
    onLogout() {
        this.retriever.removeRegionId();
        this.regionIds = [this.config.regionId];
    }
    renewJWTToken() {
        this.retriever.leaguesRetriever && this.retriever.leaguesRetriever.loadData();
    }
    detachObservables() {
        this.leaguesDisposer();
    }
    activate() {
        this.retriever.activate();
        this.attachObservables();
        this.attachMsgBusRouter();
        this.requestGlobalListeners();
    }
    selectRetriever(sportId, leagueIds) {
        this.clearData();
        this.sportId = sportId;
        this.retriever.selectRetriever(sportId, leagueIds);
    }
    deactivate() {
        this.detachObservables();
        this.detachMsgBusRouter();
        this.clearData();
        this.retriever.deactivate();
    }
    updateLeagues() {
        let leagues = this.retriever.leagues.slice();
        let regions = this.regionIds;
        if (this.sortIPTopLeaguesFirst) {
            leagues.forEach(league => {
                if (regions && league.regionId && regions.indexOf(league.regionId) >= 0) {
                    updateLeagueRankID(league, true);
                }
            });
        }
        leagues = filterLeagues(leagues, this.sportId);
        leagues = sortLeagues(leagues, this.config, this.sportId);
        leagues = mapSelected(leagues, this.selectedLeagues);
        this.leagues = leagues.map(league => {
            mapRequiredProps(league);
            mapHasLiveEvents(league);
            mapHasLiveStreaming(league);
            mapLeagueUrl(this.navigationHandler.Navigation.adjustSportsPath, league);
            return league;
        });
    }
    clearData() {
        this.leagues = [];
        this.selectedLeagues = [];
    }
    toggleSelectedLeague(leagueId) {
        if (this.selectedLeagues.length >= this.config.maxCouponLeagues && this.selectedLeagues.indexOf(leagueId) === -1) {
            return false;
        }
        else {
            this.updateSelectedLeagues(leagueId);
            this.toggleIsSelectedLeagues(leagueId);
            return true;
        }
    }
    updateSelectedLeagues(leagueId) {
        let selLeagues = this.selectedLeagues.slice();
        const selectedIndex = selLeagues.indexOf(leagueId);
        selectedIndex > -1 ? selLeagues.splice(selectedIndex, 1) : selLeagues.push(leagueId);
        this.selectedLeagues = selLeagues;
    }
    toggleIsSelectedLeagues(leagueId) {
        let leagues = this.leagues.slice();
        const leagueIndex = this.leagues.findIndex(league => league.id === leagueId);
        if (leagueIndex > -1) {
            leagues[leagueIndex].isSelected = !leagues[leagueIndex].isSelected;
        }
        this.leagues = leagues;
    }
    get getTopLeaguesOnly() {
        return filterOnlyTopLeagues(this.leagues, this.regionIds);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "leagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "selectedLeagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Parser.prototype, "isLoading", void 0);
__decorate([
    Debounce,
    __metadata("design:type", Object)
], Parser.prototype, 100, void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "clearData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateSelectedLeagues", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "toggleIsSelectedLeagues", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Parser.prototype, "getTopLeaguesOnly", null);
//# sourceMappingURL=Parser.js.map